import { useNavigate } from 'react-router-dom'
import { useTenantGroups } from '../../hooks/useTenantGroups'
import { TenantGroupsTable } from '../../components/TenantGroupsTable/TenantGroupsTable'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'

export function TenantGroupsPage() {
  const { tenantGroups, isLoading, error } = useTenantGroups()
  const navigate = useNavigate()

  return (
    <ListEntityPage
      title="Tenant groups"
      description="Groups of tenants that share payment profiles and inventory system profiles."
      loadingLabel="tenant groups"
      isLoading={isLoading}
      error={error}
      createHref="/tenant-groups/create"
      createLabel="New tenant group"
    >
      <TenantGroupsTable
        tenantGroups={tenantGroups}
        onRowClick={(g) => navigate(`/tenant-groups/${g.id}`)}
      />
    </ListEntityPage>
  )
}
